import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon, ArrowRightIcon, LeafIcon } from 'lucide-react';
import { TreatmentList } from '../components/TreatmentList';
import { TrustBadges } from '../components/TrustBadges';
import { Reveal } from '../components/Reveal';
import { treatments, bindweefsel, treatmentIncludes } from '../data/treatments';
import { founder, philosophy, salon } from '../data/content';
import { useStore } from '../contexts/StoreContext';
const categories = ['Anti-ageing', 'Huidverbetering', 'Ontspanning', 'Losse applicaties'] as const;
export function Treatments() {
  const {
    openBooking
  } = useStore();
  const [active, setActive] = useState<(typeof categories)[number] | 'Alles'>('Alles');
  const groups = categories.map(c => ({
    category: c,
    items: treatments.filter(t => t.category === c)
  })).filter(g => active === 'Alles' ? g.items.length > 0 : g.category === active);
  return <>
      {/* Hero */}
      <section className="bg-sand" data-id="element-585" data-mp="2zir3jf8jbigu">
        <div className="mx-auto grid max-w-content gap-12 px-6 pb-16 pt-12 lg:grid-cols-12 lg:gap-16 lg:px-10 lg:pb-20 lg:pt-16" data-id="element-586" data-mp="2zjtshhmarau4">
          <div className="lg:col-span-7" data-id="element-587" data-mp="2ulijf93tt4cy">
            <p className="rule-label text-[11px] uppercase tracking-widest text-clay" data-id="element-588" data-mp="38j770opa2plp">
              Behandelingen · {salon.city}
            </p>
            <h1 className="mt-7 max-w-2xl font-display text-[2.7rem] font-light leading-[1.02] text-ink sm:text-6xl" data-id="element-589" data-mp="34gahsf58fv8s">
              Huid weer vol leven,
              <span className="italic text-clay" data-id="element-590" data-mp="3ditk8y53w5ui"> van binnenuit.</span>
            </h1>
            <p className="mt-7 max-w-xl text-[17px] leading-relaxed text-muted" data-id="element-591" data-mp="3s7g51fdi5pt4">
              Vrijwel elke behandeling draait om de bindweefselmassage: de fitnessoefening voor je
              huid. Daaromheen bouwen we op wat jouw huid die dag nodig heeft — van pigment en
              roodheid tot verslapping en pure ontspanning.
            </p>

            <div className="mt-9" data-id="element-592" data-mp="589vjqkky6m">
              <p className="text-[11px] uppercase tracking-widest text-muted" data-id="element-593" data-mp="1ssubdc5f2k">
                Elke behandeling is inclusief
              </p>
              <ul className="mt-4 flex flex-wrap gap-x-6 gap-y-2" data-id="element-594" data-mp="2yvrle2f30qgk">
                {treatmentIncludes.map(item => <li key={item} className="flex items-center gap-2 text-[13px] text-ink" data-id="element-595" data-mp="32uqodhh96d5d">
                    <CheckIcon className="h-3.5 w-3.5 text-clay" strokeWidth={1.75} data-id="element-596" data-mp="37ntiprtutqmm" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="lg:col-span-5" data-id="element-597" data-mp="3hjms52ca1406">
            <div className="relative" data-id="element-598" data-mp="3mkaswfqb4z7l">
              <img src={founder.atWork} alt={`${founder.name} tijdens een gezichtsbehandeling`} className="arch aspect-[4/5] w-full object-cover" data-id="element-599" data-mp="3mlc6orypjzt0" />
              <figure className="mt-4 flex items-center gap-3 rounded-full bg-shell px-4 py-3 ring-1 ring-line sm:absolute sm:-bottom-5 sm:-left-4 sm:mt-0" data-id="element-600" data-mp="1s7kx1sgdpfxk">
                <img src={founder.portrait} alt="" className="h-10 w-10 rounded-full object-cover object-top" data-id="element-601" data-mp="1oo2e21thlvci" />
                <figcaption className="text-[12px] leading-snug text-muted" data-id="element-602" data-mp="1jvsssz3bhjgk">
                  Altijd behandeld door <span className="text-ink" data-id="element-603" data-mp="1awxjvf8w1v9k">{founder.name}</span>
                </figcaption>
              </figure>
            </div>
          </div>
        </div>
      </section>

      {/* Bindweefselmassage feature */}
      <section className="bg-ink py-20 text-shell lg:py-28" aria-labelledby="bindweefsel" data-id="element-604" data-mp="22od6h9ag3hzs">
        <div className="mx-auto max-w-content px-6 lg:px-10" data-id="element-605" data-mp="1ym9pk550bl74">
          <div className="grid gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-606" data-mp="1ykoxqna2ugcy">
            <div className="lg:col-span-5" data-id="element-607" data-mp="1tmdn4abyk1to">
              <p className="text-[11px] uppercase tracking-widest text-rose" data-id="element-608" data-mp="1tprp3hgpm90l">
                {bindweefsel.title}
              </p>
              <h2 id="bindweefsel" className="mt-5 font-display text-4xl font-light leading-[1.08] sm:text-5xl" data-id="element-609" data-mp="i7qnomwwphrh">
                {bindweefsel.claim}
              </h2>
              <p className="mt-6 max-w-md text-[15px] leading-relaxed text-shell/70" data-id="element-610" data-mp="2avy5kwmajjq5">
                {bindweefsel.intro}
              </p>
              <p className="mt-6 inline-flex items-center gap-2 rounded-full border border-shell/25 px-4 py-2 text-[13px] text-shell/80" data-id="element-611" data-mp="1x26qz9tpd9nk">
                {bindweefsel.rhythm}
              </p>
              <div className="mt-8 flex flex-wrap gap-3" data-id="element-612" data-mp="2ow8sjokhce61">
                <button type="button" onClick={() => openBooking('Bindweefselmassage')} className="rounded-full bg-shell px-6 py-3.5 text-sm text-ink transition-colors duration-150 ease-soft hover:bg-blush" data-id="element-613" data-mp="2tusj62a0qe4q">
                  Boek een bindweefselmassage
                </button>
                <Link to="/webshop" className="inline-flex items-center gap-2 rounded-full border border-shell/30 px-6 py-3.5 text-sm text-shell transition-colors duration-150 ease-soft hover:border-shell" data-id="element-614" data-mp="14hp2htzhal65">
                  Het vitamine C serum erbij
                  <ArrowRightIcon className="h-4 w-4" strokeWidth={1.5} data-id="element-615" data-mp="wyfpzrvoe6cv" />
                </Link>
              </div>
            </div>

            <div className="grid gap-10 lg:col-span-7 lg:grid-cols-2 lg:gap-12" data-id="element-616" data-mp="15w9nh656f61m">
              <div data-id="element-617" data-mp="i76wh7onk0ug">
                <h3 className="text-[11px] uppercase tracking-widest text-shell/50" data-id="element-618" data-mp="i6f9umd19dgb">
                  Voor wie is het goed?
                </h3>
                <ul className="mt-5 divide-y divide-shell/12 border-y border-shell/12" data-id="element-619" data-mp="d9x53mhpdf3z">
                  {bindweefsel.forWho.map(item => <li key={item} className="py-4 text-[15px] leading-snug text-shell/85" data-id="element-620" data-mp="n5rtky8ly4eo">
                      {item}
                    </li>)}
                </ul>
              </div>
              <div data-id="element-621" data-mp="3qns7eu0uh407">
                <h3 className="text-[11px] uppercase tracking-widest text-shell/50" data-id="element-622" data-mp="3qm7bp12snf0r">
                  Wat doet het?
                </h3>
                <ul className="mt-5 divide-y divide-shell/12 border-y border-shell/12" data-id="element-623" data-mp="1ui19zj6hsga2">
                  {bindweefsel.effects.map(item => <li key={item} className="py-4 text-[15px] leading-snug text-shell/85" data-id="element-624" data-mp="249f75kaz1401">
                      {item}
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Treatment lists */}
      <section className="bg-sand py-16 lg:py-24" data-id="element-625" data-mp="1gjb2rapyl07z">
        <div className="mx-auto max-w-content px-6 lg:px-10" data-id="element-626" data-mp="1gm7293hgfwyj">
          <div className="flex flex-wrap items-center gap-2" data-id="element-627" data-mp="1kkwm9ex00cr5">
            {(['Alles', ...categories] as const).map(c => <button key={c} type="button" aria-pressed={active === c} onClick={() => setActive(c)} className={`rounded-full border px-5 py-2 text-[13px] transition-colors duration-150 ease-soft ${active === c ? 'border-ink bg-ink text-shell' : 'border-line text-muted hover:border-ink hover:text-ink'}`} data-id="element-628" data-mp="1pioc83e31osp">
                {c}
              </button>)}
          </div>

          <div className="mt-12 space-y-16" data-id="element-629" data-mp="2xd9i4yxx21vx">
            {groups.map(group => <div key={group.category} data-id="element-630" data-mp="2sd3hwudkz728">
                <h2 className="rule-label font-display text-2xl font-light text-ink" data-id="element-631" data-mp="2sey74kvvxlc4">
                  {group.category}
                </h2>
                <div className="mt-6" data-id="element-632" data-mp="2if7delf5fad3">
                  <TreatmentList items={group.items} data-id="element-633" data-mp="2ig8lqi4s5ir4" />
                </div>
              </div>)}
          </div>
        </div>
      </section>

      <TrustBadges tone="shell" data-id="element-634" data-mp="2efyfd4d2sqbq" />

      {/* Philosophy */}
      <section className="bg-sand py-20 lg:py-28" data-id="element-635" data-mp="gnapecbso81f">
        <div className="mx-auto grid max-w-content gap-12 px-6 lg:grid-cols-12 lg:gap-16 lg:px-10" data-id="element-636" data-mp="cmifrhz0g14m">
          <div className="lg:col-span-5" data-id="element-637" data-mp="vv8vwm0ov6ok">
            <img src={founder.withProducts} alt={`${founder.name} met de producten waar ze mee werkt`} className="arch aspect-[4/5] w-full object-cover" data-id="element-638" data-mp="vwa9ax56g59g" />
          </div>
          <Reveal className="lg:col-span-7 lg:self-center" data-id="element-639" data-mp="m332r8ypaj7s">
            <p className="text-[11px] uppercase tracking-widest text-clay" data-id="element-640" data-mp="r38qie1unlkl">Eerlijk vooraf</p>
            <blockquote className="mt-5 font-display text-4xl font-light leading-[1.1] text-ink sm:text-5xl" data-id="element-641" data-mp="c5yff5t4chpe">
              “{philosophy.claim}.”
            </blockquote>
            <p className="mt-7 max-w-xl text-[15px] leading-relaxed text-muted" data-id="element-642" data-mp="36l385dm1f0z">
              {philosophy.body}
            </p>
            <p className="mt-6 flex items-start gap-3 border-t border-line pt-6 text-[14px] leading-relaxed text-muted" data-id="element-643" data-mp="86fvodd1aco5">
              <LeafIcon className="mt-0.5 h-4 w-4 shrink-0 text-clay" strokeWidth={1.5} data-id="element-644" data-mp="1xkvs2du7g96r" />
              Natuurlijke, vegan, organische en zinvolle producten. Daar werk ik mee — emerginC,
              Flower &amp; Spice, Raaw by Trice en Inika Organics.
            </p>
            <Link to="/webshop" className="mt-7 inline-flex items-center gap-2 text-sm text-ink underline-offset-4 transition-colors duration-150 ease-soft hover:text-clay hover:underline" data-id="element-645" data-mp="27p2hjiiq9h4c">
              Bekijk waar ik mee werk
              <ArrowRightIcon className="h-4 w-4" strokeWidth={1.5} data-id="element-646" data-mp="2vdvffkiwtz1l" />
            </Link>
          </Reveal>
        </div>
      </section>

      {/* Closing */}
      <section className="border-t border-line bg-shell py-16 lg:py-20" data-id="element-647" data-mp="2qe91f8v9cerq">
        <div className="mx-auto flex max-w-content flex-col items-start gap-8 px-6 lg:flex-row lg:items-center lg:justify-between lg:px-10" data-id="element-648" data-mp="34etju3x9g8kp">
          <div className="max-w-xl" data-id="element-649" data-mp="30au7zymxdxxo">
            <h2 className="font-display text-3xl font-light leading-tight text-ink" data-id="element-650" data-mp="19zzdugyuau1y">
              Twijfel je welke behandeling past?
            </h2>
            <p className="mt-3 text-[15px] leading-relaxed text-muted" data-id="element-651" data-mp="160qlngjg748i">
              Boek een gratis Shelfie Time van 30 minuten — kennismaking en huidadvies, ook online.
              Of mail naar {salon.email}, dan neem ik binnen 24 uur contact op.
            </p>
          </div>
          <div className="flex flex-wrap gap-3" data-id="element-652" data-mp="25duhtxyxdg4f">
            <button type="button" onClick={() => openBooking('Shelfie Time')} className="rounded-full bg-ink px-7 py-3.5 text-sm text-shell transition-colors duration-150 ease-soft hover:bg-clay" data-id="element-653" data-mp="20dyf021yruqg">
              Plan Shelfie Time
            </button>
            <a href={salon.whatsapp} className="rounded-full border border-ink/20 px-7 py-3.5 text-sm text-ink transition-colors duration-150 ease-soft hover:border-ink" data-id="element-654" data-mp="2obnlx3labw3e">
              Stel je vraag via WhatsApp
            </a>
          </div>
        </div>
      </section>
    </>;
}